import { TOGGLE_SNACKBAR } from './../events';

function data() {
	return {
		localAddress: {
			addressLocation: '',
			address: '',
			alias: '',
			latitude: 0,
			longitude: 0,
		},
		openValue: false,
		snackbar: {
			text: '',
			isVisible: false,
			color: 'primary',
			timeout: 0,
		},
	};
}

function goTo(name, options) {
	this.$router.push({ name, ...options });
}

function replaceString(word, selectionStart, newWord) {
	if (word) {
		return word.slice(0, selectionStart) + newWord + word.slice(selectionStart + 0);
	}
	return newWord;
}

function showNotification(text, color = 'green', timeout = 5000) {
	this.$bus.$emit(TOGGLE_SNACKBAR, { color, text, timeout });
}

function showGenericError(text = 'Ups, ocurrió algún problema') {
	this.showNotification(text, 'error');
}

function onToggleSnackBar() {
	this.$bus.$on(TOGGLE_SNACKBAR, (snackbar) => {
		const newSnackbar = Object.assign({}, snackbar);
		newSnackbar.isVisible = true;
		this.snackbar = newSnackbar;
	});
}

function goToHome() {
	this.goTo('page-home');
}

function isForm() {
	return this.$route.hash === '#formulario';
}

function setLocalAddress() {
	const localData = localStorage.getItem('casamarket::location-data');
	if (localData) {
		this.$bus.$emit('address-modal', localData);
	}
}

function onLocalAddress() {
	this.$bus.$on('address-modal', (response) => {
		this.localAddress = JSON.parse(response);
	});
}

function openLocationModal(value) {
	this.$bus.$emit('open-address-modal', value);
}

function onOpenLocationModal() {
	this.$bus.$on('open-address-modal', (response) => {
		this.openValue = response;
	});
}

const mixin = {
	data,
	methods: {
		goTo,
		goToHome,
		onLocalAddress,
		onOpenLocationModal,
		onToggleSnackBar,
		openLocationModal,
		replaceString,
		setLocalAddress,
		showGenericError,
		showNotification,
	},
	computed: {
		isForm,
	},
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/global.js